import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 2,
  class: "container-fluid",
  style: {"margin-top":"80px","padding-top":"40px"}
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-6" }
const _hoisted_4 = { class: "mb-3" }
const _hoisted_5 = { class: "btn-group mr-1" }
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "btn-group mr-1" }
const _hoisted_10 = {
  class: "btn btn-outline-secondary dropdown-toggle",
  type: "button",
  "data-toggle": "dropdown"
}
const _hoisted_11 = { class: "dropdown-menu" }
const _hoisted_12 = {
  key: 0,
  class: "btn-group mr-1"
}
const _hoisted_13 = {
  type: "button",
  class: "btn btn-outline-secondary dropdown-toggle",
  "data-toggle": "dropdown"
}
const _hoisted_14 = { class: "dropdown-menu dropdown-menu-right" }
const _hoisted_15 = ["onClick"]

import { computed, ref, watch, onMounted } from 'vue'
    import { useRoute } from 'vue-router'
    import PortfolioNavigation from '@common/Components/PortfolioNavigation.vue'
    import Navigation from '@common/Navigation.vue'
    import ProjectNavigation from '@Quest/ProjectPlans/Components/ProjectNavigation.vue'
    import ProjectContextHeader from '@Quest/ProjectPlans/Components/ProjectContextHeader.vue'
    import PnlViewer from '@Quest/Pnls/Components/PnlViewer.vue'
    import type { CurrencyDenomination } from '@common/types'
    import { useProjectPlanPnlQueryV1 } from '@Quest/ProjectPlans/queries-vue-composables'
    import { useUpdateBenefitsConfidenceFactorCommandV1 } from '@Quest/ProjectPlans/commands-vue-composables'
    import type { ProjectPnlReadModel } from '@Quest/ProjectPlans/readmodels'
    import type { PnlReportReadModel } from '@Quest/Pnls/readmodels'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'PnlPage',
  setup(__props) {

    const route = useRoute()

    const workspaceId = computed(() => Number(route.params.workspaceId ?? 0))
    const tchProjectId = computed(() => Number(route.params.tchProjectId ?? 0))
    const projectId = computed(() => String(route.params.projectId ?? ''))

    const projectPlanId = computed<string | null>(() => rm.value?.ProjectPlanId ?? null)
    const denomination = computed<CurrencyDenomination | null>(() => rm.value?.Denomination ?? null)

    const projectName = computed<string | null>(() => rm.value?.ProjectName ?? null)
    const projectPlanName = computed<string>(() => rm.value?.ProjectPlanName ?? '')
    const activePlanId = computed<string | null>(() => rm.value?.ActiveProjectPlanId ?? null)

    const applyBenefitsConfidenceFactor = computed<boolean>(() => rm.value?.ApplyBenefitsConfidenceFactor ?? false)
    const pnlId = computed<string | null>(() => rm.value?.PnlId ?? null)
    const report = computed<PnlReportReadModel | null>(() => rm.value?.Report ?? null)

    const portfolioId = computed(() => rm.value?.PortfolioId ?? null)
    const userId = computed(() => rm.value?.UserId ?? 0)
    const isWorkspaceMember = computed(() => rm.value?.IsWorkspaceMember ?? false)
    const isProjectOwner = computed(() => rm.value?.IsProjectOwner ?? false)
    const pnlTemplates = computed(() => rm.value?.PnlTemplates ?? [])

    const cagrVisible = ref(false)
    const benefitsConfidenceFactorInput = ref<number | null>(null)
    const savingBenefitsConfidenceFactorInput = ref(false)

    const {
        runProjectPlanPnlQueryV1,
        modelProjectPlanPnlQueryV1
    } = useProjectPlanPnlQueryV1(workspaceId, tchProjectId, projectId, projectPlanId, pnlId, applyBenefitsConfidenceFactor, denomination)

    const rm = ref<ProjectPnlReadModel | null>(null)


    const selectedPnl = computed(() =>
    {
        if (!pnlTemplates.value.length) return null

        return (
            (pnlId.value
                ? pnlTemplates.value.find(a => a.Id === pnlId.value)
                : pnlTemplates.value.find(a => a.IsDefault === true)
            ) ?? null
        )
    })

    const benefitsConfidenceFactorLabel = computed(() =>
    {
        const val = rm.value?.BenefitsConfidenceFactorValue
        return val != null ? `${val}%` : '100%'
    })


    function toggleBenefitsConfidenceFactor()
    {
        runProjectPlanPnlQueryV1({
            ApplyBenefitsConfidenceFactor: !applyBenefitsConfidenceFactor.value
        })
    }

    function switchPnlTemplate(id: string | null)
    {
        runProjectPlanPnlQueryV1({
            PnlId: id
        })
    }


    function toggleCagrVisible()
    {
        cagrVisible.value = !cagrVisible.value
    }



    function setDenomination(d: CurrencyDenomination)
    {
        runProjectPlanPnlQueryV1({
            Denomination: d
        })
    }

    const {
        invokeUpdateBenefitsConfidenceFactorCommandV1,
        onSucceedUpdateBenefitsConfidenceFactorCommandV1
    } = useUpdateBenefitsConfidenceFactorCommandV1(userId, workspaceId, portfolioId, projectId, projectPlanId, benefitsConfidenceFactorInput)

    function handleUpdateBenefitsConfidenceFactorCommand()
    {
        savingBenefitsConfidenceFactorInput.value = true
        invokeUpdateBenefitsConfidenceFactorCommandV1()
    }

    onMounted(() =>
    {
        document.title = 'Project P&L | TransparentChoice'

        runProjectPlanPnlQueryV1({
            ProjectPlanId: route.params.planId ? String(route.params.planId) : null,
            Denomination: route.query.denomination as CurrencyDenomination ?? null,
        })
    })

    watch(() => route.params.planId, () =>
    {
        runProjectPlanPnlQueryV1({
            ProjectPlanId: route.params.planId as string | null
        })
    })


    watch(modelProjectPlanPnlQueryV1, (current) =>
    {
        if (current?.RedirectUrl)
        {
            window.location.replace(current.RedirectUrl)
        }

        if (current)
        {
            rm.value = current
            benefitsConfidenceFactorInput.value = current.BenefitsConfidenceFactorValue
        }
    })

    onSucceedUpdateBenefitsConfidenceFactorCommandV1(() =>
    {
        savingBenefitsConfidenceFactorInput.value = false
        runProjectPlanPnlQueryV1()
    })


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (isWorkspaceMember.value)
      ? (_openBlock(), _createBlock(PortfolioNavigation, {
          key: 0,
          workspaceId: workspaceId.value,
          projectId: tchProjectId.value
        }, null, 8 /* PROPS */, ["workspaceId", "projectId"]))
      : (isProjectOwner.value)
        ? (_openBlock(), _createBlock(Navigation, { key: 1 }))
        : _createCommentVNode("v-if", true),
    (rm.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(ProjectContextHeader, {
                projectName: projectName.value,
                planId: projectPlanId.value,
                planName: projectPlanName.value,
                activePlanId: activePlanId.value
              }, null, 8 /* PROPS */, ["projectName", "planId", "planName", "activePlanId"])
            ]),
            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "col-lg-6 text-right align-self-end" }, null, -1 /* CACHED */))
          ]),
          _cache[11] || (_cache[11] = _createElementVNode("hr", null, null, -1 /* CACHED */)),
          _createVNode(ProjectNavigation, {
            ActivePage: "pnl",
            class: "mt-4 mb-4",
            workspaceId: workspaceId.value,
            tchProjectId: tchProjectId.value,
            projectId: projectId.value,
            planId: projectPlanId.value
          }, null, 8 /* PROPS */, ["workspaceId", "tchProjectId", "projectId", "planId"]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass(["mr-1", cagrVisible.value ? 'btn btn-info' : 'btn btn-outline-secondary']),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleCagrVisible()))
            }, [
              _createElementVNode("i", {
                class: _normalizeClass(cagrVisible.value ? 'fa-regular fa-square-check' : 'fa-regular fa-square')
              }, null, 2 /* CLASS */),
              _cache[8] || (_cache[8] = _createTextVNode(" CAGR ", -1 /* CACHED */))
            ], 2 /* CLASS */),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(applyBenefitsConfidenceFactor.value ? 'btn btn-danger' : 'btn btn-outline-secondary'),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (toggleBenefitsConfidenceFactor()))
              }, [
                _createElementVNode("i", {
                  class: _normalizeClass(applyBenefitsConfidenceFactor.value ? 'fa-regular fa-square-check' : 'fa-regular fa-square')
                }, null, 2 /* CLASS */),
                _createTextVNode(" Risk adjusted benefits (" + _toDisplayString(benefitsConfidenceFactorLabel.value) + ") ", 1 /* TEXT */)
              ], 2 /* CLASS */),
              _cache[10] || (_cache[10] = _createElementVNode("button", {
                type: "button",
                class: "btn btn-outline-secondary dropdown-toggle-split rounded-right",
                "data-toggle": "dropdown",
                "aria-expanded": "false"
              }, [
                _createElementVNode("i", { class: "fa fa-pencil" }),
                _createElementVNode("span", { class: "sr-only" }, "Toggle Dropdown")
              ], -1 /* CACHED */)),
              _createElementVNode("div", {
                class: "dropdown-menu dropdown-menu-right p-2",
                style: {"width":"100%"},
                onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
              }, [
                _createElementVNode("form", {
                  onSubmit: _withModifiers(handleUpdateBenefitsConfidenceFactorCommand, ["prevent"])
                }, [
                  _createElementVNode("div", _hoisted_6, [
                    _cache[9] || (_cache[9] = _createElementVNode("label", null, "Benefits confidence factor (0-100):", -1 /* CACHED */)),
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((benefitsConfidenceFactorInput).value = $event)),
                      placeholder: "100",
                      min: "0",
                      max: "100",
                      step: "0.1",
                      disabled: savingBenefitsConfidenceFactorInput.value
                    }, null, 8 /* PROPS */, _hoisted_7), [
                      [
                        _vModelText,
                        benefitsConfidenceFactorInput.value,
                        void 0,
                        { number: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("button", {
                    type: "submit",
                    class: "btn btn-primary",
                    disabled: savingBenefitsConfidenceFactorInput.value
                  }, "Update", 8 /* PROPS */, _hoisted_8)
                ], 32 /* NEED_HYDRATION */)
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("button", _hoisted_10, _toDisplayString(denomination.value) + "s ", 1 /* TEXT */),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("a", {
                  class: "dropdown-item",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => {setDenomination('Million');})
                }, "Millions"),
                _createElementVNode("a", {
                  class: "dropdown-item",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => {setDenomination('Thousand');})
                }, "Thousands"),
                _createElementVNode("a", {
                  class: "dropdown-item",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => {setDenomination('Unit');})
                }, "Units")
              ])
            ]),
            (pnlTemplates.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("button", _hoisted_13, "P&L: " + _toDisplayString(selectedPnl.value?.Name), 1 /* TEXT */),
                  _createElementVNode("div", _hoisted_14, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pnlTemplates.value, (t) => {
                      return (_openBlock(), _createElementBlock("a", {
                        class: "dropdown-item",
                        key: t.Id,
                        onClick: ($event: any) => (switchPnlTemplate(t.Id))
                      }, _toDisplayString(t.Name), 9 /* TEXT, PROPS */, _hoisted_15))
                    }), 128 /* KEYED_FRAGMENT */))
                  ])
                ]))
              : _createCommentVNode("v-if", true)
          ]),
          _createVNode(PnlViewer, {
            readModel: report.value,
            cagrVisible: cagrVisible.value
          }, null, 8 /* PROPS */, ["readModel", "cagrVisible"])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})